import { ActionType, createAsyncAction } from 'typesafe-actions';
import { convertListingPageStateToUrl } from '../../hooks/ListingPage/listingPageUrlService';
import { DefaultErrorPayload, FetchAction, SuccessFetchActionPayload } from '../dataFetching/generators';
import { ListingPageUrlState } from '../products/types';
import { DataFetchingThunkAction } from '../types';
import { log404ErrorAsWarning } from '../../../common/apiAdapters/ErrorHandlers';
import { ContentInfusionsPageTypeMapping, PageType } from '../../hooks/UrlManager/types';
import { ContentInfusionResponse } from './types';

export const fetchContentInfusionsActions = createAsyncAction(
    '@INFUSION/FETCH_START',
    '@INFUSION/FETCH_SUCCESS',
    '@INFUSION/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<ContentInfusionResponse>, DefaultErrorPayload>();

export const fetchContentInfusionIfNeeded = (urlState: ListingPageUrlState): DataFetchingThunkAction => async (
    dispatch,
    getState,
    { apiService, logger }
) => {
    const identifier = convertListingPageStateToUrl(urlState);
    if (identifier === getState().infusions.identifier) {
        return;
    }
    const { listingPageKey, listingPageType } = urlState;
    const pageType = ContentInfusionsPageTypeMapping[listingPageType]
        ? ContentInfusionsPageTypeMapping[listingPageType]
        : listingPageType;

    const pageKey = listingPageType === PageType.NEWPRODUCTS ? '' : listingPageKey;

    dispatch(fetchContentInfusionsActions.request({ identifier }));
    try {
        const infusions = await apiService.shopApi.getContentInfusion(pageType, pageKey);
        dispatch(fetchContentInfusionsActions.success({ data: infusions, identifier }));
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchContentInfusionIfNeeded');
        dispatch(fetchContentInfusionsActions.failure({ error: err, identifier }));
    }
};

export type ContentInfusionActionsType = ActionType<typeof fetchContentInfusionsActions>;
